"use strict";
// (C) 2019-2020 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertDimensions = exports.convertWarning = void 0;
var tslib_1 = require("tslib");
var api_model_bear_1 = require("@gooddata/api-model-bear");
var api_client_bear_1 = require("@gooddata/api-client-bear");
var sdk_model_1 = require("@gooddata/sdk-model");
var isAttributeHeader = api_model_bear_1.GdcExecution.isAttributeHeader;
function convertWarning(warning) {
    var _a;
    return {
        warningCode: warning.warningCode,
        message: warning.message,
        parameters: (_a = warning.parameters) === null || _a === void 0 ? void 0 : _a.map(function (param) { return (api_client_bear_1.isUri(param) ? sdk_model_1.uriRef(param) : param); }),
    };
}
exports.convertWarning = convertWarning;
/**
 * Converts execution result's dimension headers as passed by backend into dimension descriptor. At the moment, this function
 * ensures that the 'ref' properties are correctly filled in.
 *
 * @param dims - result dimensions.
 */
function convertDimensions(dims) {
    return dims.map(function (dim) {
        return {
            headers: dim.headers.map(function (header) {
                if (isAttributeHeader(header)) {
                    return {
                        attributeHeader: tslib_1.__assign(tslib_1.__assign({}, header.attributeHeader), { ref: sdk_model_1.uriRef(header.attributeHeader.uri), formOf: tslib_1.__assign(tslib_1.__assign({}, header.attributeHeader.formOf), { ref: sdk_model_1.uriRef(header.attributeHeader.formOf.uri) }) }),
                    };
                }
                else {
                    return {
                        measureGroupHeader: {
                            items: header.measureGroupHeader.items.map(function (measure) {
                                return {
                                    measureHeaderItem: tslib_1.__assign(tslib_1.__assign({}, measure.measureHeaderItem), { ref: measure.measureHeaderItem.uri
                                            ? sdk_model_1.uriRef(measure.measureHeaderItem.uri)
                                            : undefined }),
                                };
                            }),
                            totalItems: header.measureGroupHeader.totalItems,
                        },
                    };
                }
            }),
        };
    });
}
exports.convertDimensions = convertDimensions;
//# sourceMappingURL=ExecutionResultConverter.js.map